import { dayjs } from '@tunasong/models'
import type { Persisted } from '@tunasong/schemas'
import type { FC } from 'react'
import type { Game } from '@tunasong/schemas'
import { Table, TableHead, TableBody, TableRow, TableCell } from '@tunasong/ui-lib'
import { useLeaderboard } from './leaderboard.hook.js'

import type { HTMLAttributes } from 'react'

export interface LeaderBoardProps extends HTMLAttributes<HTMLDivElement> {
  game: Persisted<Game>
}

export const LeaderBoard: FC<LeaderBoardProps> = props => {
  const { game, ...restProps } = props

  const leaderBoard = useLeaderboard({ game })

  return (
    <div {...restProps}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Rank</TableCell>
            <TableCell>Nickname</TableCell>
            <TableCell>When</TableCell>
            <TableCell>Score</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {leaderBoard?.map((entry, index) => (
            <TableRow key={index}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{entry.nickName ?? 'A Girl has No Name'}</TableCell>
              <TableCell>{dayjs(entry.createdAt).fromNow()}</TableCell>
              <TableCell>{entry.score}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}

export default LeaderBoard
